const LambdaLib = require('@jurinfor/game-process/lambda').default;
const consoleDiff = require('./consoleDiff');

const { reduce } = LambdaLib;
const { LambdaJSONToString, exportToJSON } = LambdaLib.json;

function traceReduction(term, reductionSpec, { maxSteps = 20 } = {}) {
  let t = term;
  let s = "";
  console.group('steps');
  for (let i = 0; i < maxSteps; ++i) {
    s += "\n";
    s += `step #${i}. fv: ${t.fv ? [...t.fv].map(v => v.name) : 'undefined'}\n${LambdaJSONToString(exportToJSON(t))}\n`;
    const strPrev = LambdaJSONToString(exportToJSON(t));
    console.group(`step #${i}`);
    console.log(t);
    t = reduce(t, reductionSpec);
    console.groupEnd();
    if (t === undefined) {
      console.log('Finish');
      break;
    }
    const strNext = LambdaJSONToString(exportToJSON(t));
    consoleDiff(strPrev, strNext);
  }
  console.groupEnd();
  console.log(s);
}

module.exports = traceReduction;
